import styled from 'styled-components/native';

export const ChatItemContainer = styled.View`
  border-radius: 20px;

  background-color: rgba(5, 22, 51, 0.8);
`;
